import { useQuery } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';

// Fetches every supplier onboarding for an order in one request, so offer cards can be passed
// their onboarding without each fetching on its own.
export const useOrderSupplierOnboardings = (orderId: string) => {
    return useQuery({
        ...queries.supplierOnboarding.byOrderId(orderId),
        enabled: Boolean(orderId),
    });
};
